import { Component, AfterViewInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { delay } from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { User, DefaultUser } from 'src/app/models/user.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { AccountOverviewComponent } from '../account-overview/account-overview.component';
import { AccountSettingsComponent } from '../account-settings/account-settings.component';
import { AccountSecurityComponent } from '../account-security/account-security.component';
import { AccountOrdersComponent } from '../account-orders/account-orders.component';
import { AccountAssistanceComponent } from '../account-assistance/account-assistance.component';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css'],
    imports: [MatSidenavContainer, MatSidenav, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, AccountOverviewComponent, AccountSettingsComponent, AccountSecurityComponent, AccountOrdersComponent, AccountAssistanceComponent, RouterLink, MatSidenavContent, NgbNavOutlet]
})

export class AccountComponent implements AfterViewInit {

  private observer = inject(BreakpointObserver);
  private router = inject(Router);
  private account = inject(AccountService);
  private destroyRef = inject(DestroyRef);

  user: User;

  selectedPicId;

  active = 1;
  @ViewChild('sidenav1', { static: true }) sidenavAccount: MatSidenav;

  toastId: number;
  toastStatus: number | undefined;
  toastMessage: string | undefined;

  constructor() {
    this.router.events
      .pipe(takeUntilDestroyed())
      .subscribe(event =>
      {
        if (event instanceof NavigationEnd) {this.account.checkAccountStatus()}
      });
    this.initializeUser();
  }

  initializeUser() {
    this.user = DefaultUser
    this.account.userObservable
      .pipe(takeUntilDestroyed())
      .subscribe(
        (next: User) => {
          if (next != null)
            this.user = next;
          else
            this.user = DefaultUser
          this.selectedPicId = this.user.icon_index;
        }
      )
  }

  ngAfterViewInit() {
    this.observer
      .observe(['(max-width: 800px)'])
      .pipe(delay(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        if (res.matches) {
          this.sidenavAccount.mode = 'over';
          this.sidenavAccount.close();
        } else {
          this.sidenavAccount.mode = 'side';
          this.sidenavAccount.open();
        }
      });
  }

  public async showToast(info: string, type: number) {
    this.toastId = (this.toastId || 0) + 1;
    const currentId = this.toastId;
    this.toastStatus = type;
    this.toastMessage = info;
    await new Promise<void>(resolve => setTimeout(resolve, 3000));
    if (this.toastId === currentId) {
      this.toastStatus = undefined;
      this.toastMessage = undefined;
    }
  }

  closeSidenavIfMobile()
  {
    if(this.sidenavAccount.mode == 'over')
      this.sidenavAccount.close();
  }

  SelectPic(num: number) {
    this.selectedPicId = num;
  }

  SaveAvatarPic() {
    let toastStr: string;
    this.account.changeAvatarPic(this.selectedPicId).subscribe(
      () => {
        this.showToast("Your account avatar is updated", 0);
      },
      (error) => {
        toastStr = "Updating avatar ";
        toastStr += this.account.getErrorStr(error.status);
        this.showToast(toastStr, 1);
      }
    );
  }
}
